export const acknowledgementStatusKey = (status) => {
  const map = {
    signed: 'acknowledgement_ok',
    cancelled: 'cancelled',
    pending: 'pending_acknowledgement',
  };

  return map[status] || null;
};

export const acknowledgementStatusLabel = (status) => {
  const map = {
    signed: 'Completed',
    cancelled: 'Cancelled',
    pending: 'Pending',
  };

  return map[status] || '—';
};
